const KEY_NAME = "authToken";
const LOCALE_NAME = "localeParam";

class LocalStorageHelper {

  static saveToken(token) {
    window.localStorage.setItem(KEY_NAME, token);
  }

  static removeToken() {
    window.localStorage.removeItem(KEY_NAME);
  }

  static getToken() {
    return window.localStorage.getItem(KEY_NAME);
  }

  static assumeIsLogged(){
    var token = LocalStorageHelper.getToken();
    return !(token === null || token === '');
  }

  static getLocale(){
    return window.localStorage.getItem(LOCALE_NAME);
  }

  static setLocale(value){
    window.localStorage.setItem(LOCALE_NAME, value);
  }

}

export default LocalStorageHelper;
